<script>
import ListDefault from "../Utils/Page/ListDefault";

export default {
    name: "List",
    mixins: [ListDefault],
    data() {
        return {
            lang: this.$ml.get('pages.plan'),

            buttons: [
                { key: 'update_plans', class: 'btn-primary', function: this.updatePlans }
            ],

            filter: {
                title: { value: null, type: 'text'},
                slug: { value: null, type: 'text'},
            },
            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'slug', is_sort: true, classes: 'text-l' },
                { key: 'title', is_sort: true, classes: 'text-l' },
                { key: 'price', is_sort: true, classes: 'text-l' },
                { key: 'active', is_sort: true, classes: 'text-l' },
            ],

            tableBody: {
                active: {
                    type: 'boolean',
                }
            },

            apiList: this.$store.getters.getApiUrl('plan'),
            pageRoute: 'plan',
            pageRouteCreate: 'plan.create',
            pageRouteEdit: 'plan.edit',
        }
    },
    methods: {
        updatePlans() {
            this.$store.commit('setLoading', true)
            axios.post(this.apiList, {
                type: 'updatePlans'
            }).then(({data}) => {
                if (data.success) {
                    this.$store.commit('setNotification', {
                        type: 'success',
                        message: this.lang.labels.plan_updated
                    })
                }
            }).finally(() => {
                this.getData()
                this.$store.commit('setLoading', false)
            })
        }
    }
}
</script>

<style scoped>

</style>
